import React from 'react';

const Pulse = () => {
  return (
    <div className="section" id="latest">
      <h2>Pulse Check</h2>
      <p>
        This section provides the latest updates and the state of several ongoing issues or injuries that need attention. 
      </p>
      <div className="card-container">
        <div className="latest-updates">
          <p><strong>Basic State</strong></p>
          <ul>
            <li>Received annual physical results and LDL down 71 points ApoB down 24 points both in range now</li>
            <li>Continuing to analyze shifts to HRV with Electrolyte mixes (mixed results)</li>
            <li>Signed up for Levels Food App and ordered Dexcom GCM devices for understanding more about food intake</li>
            <li>Add PQQ supplement into my routine</li>
          </ul>
        </div>

        <div className="latest-updates">
          <p><strong>Sleep and Recovery</strong></p>
          <ul>
            <li>Sleep consistency at 77% for the week with 90% efficiency</li>
            <li>Recovery is at 58% and below the 30 day average of 66%</li>
            <li>Average strain of 15.4 above the 30 day average of 14.4</li>
            <li>HRV steady with more changes on both the upper and lower levels</li>
          </ul>
        </div>

        <div className="latest-updates">
          <p><strong>Site Updates</strong></p>
          <ul>
            <li>Updated trends graphics from both Whoop and Apple for 1 year trends</li>
            <li>Nutrition page updated with new supplements and monitoring items</li>
            <li>Updated test and equipment based on new items incorporated</li>
            <li>Added new Fixes section below Red Flags for items that have improved</li>
          </ul>
        </div>
      </div>
      <h4>Red Flags</h4>
      <div className="card-container">
        <div className="latest-updates-flags">
          <p><strong>Afib(8x) Last Dec 2024</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>Torn L Meniscus 2019</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>Low HRV Oct 2024</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>Low DHEA Jan 2025</strong></p>
        </div>
        <div className="latest-updates-flags">
          <p><strong>High MPO March 2025</strong></p>
        </div>
      </div>
      <p>Note: If you want to see more of my red flags and full biomarkers login for access.</p>
<h4>Interventions (Fixes)</h4>
      <div className="card-container">
        <div className="latest-updates-fixes">
          <p><strong>Kidney Stone Sep 2022</strong></p>
          <span className="info-icon">i
            <span className="tooltip">Passed naturally, removed protein bars, sausage meat, no recurrence.</span>
          </span>
        </div>
        <div className="latest-updates-fixes">
          <p><strong>High LDL Chol - Fixed May 2025</strong></p>
          <span className="info-icon">i
            <span className="tooltip">Significant points dropped via fitness, cutting animal proteins (Meat & Chicken), and adding cinnamon, ginger power, garlic pills to my daily routine for inflammation.</span>
          </span>
        </div> 
        <div className="latest-updates-fixes">
          <p><strong>High ApoB - Fixed May 2025</strong></p>
                    <span className="info-icon">i
            <span className="tooltip">Significant points dropped from cutting animal proteins (Meat & Chicken) and adding cinnamon, ginger power, garlic pills to my daily routine for inflammation.</span>
          </span>
        </div>
      </div>
      <p>Note: To learn more about my history and fixes check out the Rhodium Papers link.</p>
      <br />
    </div>
  );
};

export default Pulse;
